<template>
  <dd-modal
      :visible="matchState === matchStateEnum.SINGLE"
      :show-cancel="true"
      @cancel="hideModal"
      width="60vw"
  >
    <dd-header-card header="E-mail koppelen" style="overflow: unset">
      <div v-if="firstSelectedEmail" class="flex-col gap-xxs" style="padding-left: 60px">
        <h2 class="subject-text m-0">{{ firstSelectedEmail.subject }}</h2>
        <p class="color-black m-0">van: {{ firstSelectedEmail.from }}</p>
        <p class="color-black m-0">aan: {{ firstSelectedEmail.to }}</p>
        <p v-if="firstSelectedEmail.cc" class="color-black m-0">cc: {{ firstSelectedEmail.cc }}</p>
        <p v-if="firstSelectedEmail.bcc" class="color-black m-0">cc: {{ firstSelectedEmail.bcc }}</p>
        <div class="flex-row align-items-end gap-xxs">
          <p class="color-black m-0">{{ firstSelectedEmail.sent ? 'verzonden' : 'ontvangen' }} op: </p>
          <p class="color-black m-0">{{formattedDate}}</p>
        </div>
      </div>
      <match-component></match-component>
    </dd-header-card>
  </dd-modal>
</template>

<script>
import { mapGetters } from "vuex";
import matchStateEnum from "../../enums/MatchStateEnum";
import MatchComponent from './MatchComponent.vue';
import moment from "moment/moment";
import DateFormatEnum from "~/enums/DateFormatEnum";

export default {
  name: "MatchModal.vue",
  components:{ MatchComponent },
  methods:{
    hideModal(){
      this.$store.dispatch('email/setMatchState', undefined);
    }
  },
  computed: {
    ...mapGetters('email', [
      "matchState",
      "firstSelectedEmail"
    ]),
    matchStateEnum() {
      return matchStateEnum;
    },
    formattedDate(){
      return moment(this.firstSelectedEmail.date).format(DateFormatEnum.NEW_DISPLAY_DATETIME);
    }
  },
  watch:{
    matchState(){
      if (this.matchState === matchStateEnum.SINGLE){
        this.$nextTick(() => document.querySelector('#detailed-customer-search-input input')?.focus());
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/_default.scss";
.subject-text{
  width: auto;
  word-break: break-word;
  overflow: hidden;
  padding-right: $spacing-md;
}
.subject-text:first-letter {
  text-transform: uppercase;
}
</style>
